import {defineStore} from "pinia";

export const useConfigStore = defineStore('config', () => {
    const baseUrl = import.meta.env.VITE_API_BASE_URL;
    const googleApiKey = import.meta.env.VITE_GOOGLE_API_KEY;
    const supportPhone = import.meta.env.VITE_SUPPORT_PHONE;
    const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL;
    const dashboardUrl = import.meta.env.VITE_DASHBOARD_URL ?? 'https://dashboard.fixr.com'

    return {
        baseUrl,
        googleApiKey,
        supportPhone,
        supportEmail,
        dashboardUrl
    }
});